import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';


const initialData = {
  collectorDetail: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,

};

const slice = createSlice({
  name: 'agentInformation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchCollectorDetail: (state, action) => {
      state.collectorDetail = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchError, fetchCollectorDetail, fetchSuccess} = slice.actions;
export const getCollectorDetails = (accountnumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`collector/information/get/collector/details/${accountnumber}`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchCollectorDetail(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
